function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { attachSubComponents, InternalProvider } from '../../util';
import { Container, Heading } from './elements';
import { DateCard } from './DateCard';
import { TimeSlot, TimeContainer } from './TimeSlot';
import { Carousel } from './Carousel';
import { NoTimesAvailable, NoTimesAvailableHeading, NoTimesAvailableSubheading } from './NoTimesAvailable';
export const Scheduler = attachSubComponents('Scheduler', /*#__PURE__*/React.forwardRef(({
  children,
  ariaLabel,
  ...rest
}, fRef) => /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(Container, _extends({
  ref: fRef,
  "aria-label": ariaLabel
}, rest), children))), {
  Heading,
  DateCard,
  TimeSlot,
  Carousel,
  TimeContainer,
  NoTimesAvailableHeading,
  NoTimesAvailableSubheading,
  NoTimesAvailable
});